import * as yup from 'yup';

export const commonRevenueReconciliationReportValidation: { [x: string]: any; } = {
    printer: yup.string().required("Missing."),
    currency: yup.string().required("Missing."),
};

export const createRevenueReconciliationReportValidation: { [x: string]: any; } = {
    ...commonRevenueReconciliationReportValidation,
};

export const createRevenueReconciliationReportValidationSchema = yup.object().shape(createRevenueReconciliationReportValidation);

